import axios from "axios";

export const user = axios.create({
  baseURL: "https://techan-a45c8-default-rtdb.firebaseio.com/",
  headers: {
    "Content-Type": "application/json",
  },
});
